import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import { u as useVoicePlayerContext, b as AudioUnitDefaultValue } from '../index-fa5b2b8c.js';
import { g as VOICE_PLAYER_AUDIO_ID } from '../consts-fa6ab3c0.js';
import { useVoiceRecorderContext } from '../VoiceRecorder/context.js';
import '../_rollupPluginBabelHelpers-05128ded.js';
import '../useSendbirdStateContext.js';
import '../withSendbird.js';
import '../LocalizationContext-a82461b5.js';
import '../stringSet-b60e9529.js';
import '../index-6add7940.js';
import '../ui/Modal.js';
import 'react-dom';
import '../index-a9101009.js';
import '../ui/Button.js';
import '../index-6420013c.js';
import 'prop-types';
import '../ui/Icon.js';
import '../ui/IconButton.js';
import '../MediaQueryContext-d6110905.js';
var generateGroupKey = function generateGroupKey() {
  var channelUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "".concat(channelUrl, "-").concat(key);
};
var useVoicePlayer = function useVoicePlayer(_ref) {
  var _voicePlayerStore$aud;
  var _ref$key = _ref.key,
    key = _ref$key === void 0 ? '' : _ref$key,
    _ref$channelUrl = _ref.channelUrl,
    channelUrl = _ref$channelUrl === void 0 ? '' : _ref$channelUrl,
    _ref$audioFile = _ref.audioFile,
    audioFile = _ref$audioFile === void 0 ? null : _ref$audioFile,
    _ref$audioFileUrl = _ref.audioFileUrl,
    audioFileUrl = _ref$audioFileUrl === void 0 ? '' : _ref$audioFileUrl;
  var _useState = useState(generateGroupKey(channelUrl, key)),
    _useState2 = _slicedToArray(_useState, 1),
    groupKey = _useState2[0];
  var _useVoicePlayerContex = useVoicePlayerContext(),
    play = _useVoicePlayerContex.play,
    pause = _useVoicePlayerContex.pause,
    stop = _useVoicePlayerContex.stop,
    voicePlayerStore = _useVoicePlayerContex.voicePlayerStore;
  var _useVoiceRecorderCont = useVoiceRecorderContext(),
    isRecordable = _useVoiceRecorderCont.isRecordable;
  var currentAudioUnit = (voicePlayerStore === null || voicePlayerStore === void 0 ? void 0 : (_voicePlayerStore$aud = voicePlayerStore.audioStorage) === null || _voicePlayerStore$aud === void 0 ? void 0 : _voicePlayerStore$aud[groupKey]) || AudioUnitDefaultValue();
  var playVoicePlayer = function playVoicePlayer() {
    if (!isRecordable) {
      play === null || play === void 0 ? void 0 : play({
        groupKey: groupKey,
        audioFile: audioFile,
        audioFileUrl: audioFileUrl
      });
    }
  };
  var pauseVoicePlayer = function pauseVoicePlayer() {
    pause === null || pause === void 0 ? void 0 : pause(groupKey);
  };
  var stopVoicePlayer = function stopVoicePlayer() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    stop === null || stop === void 0 ? void 0 : stop(text);
  };
  useEffect(function () {
    return function () {
      if (audioFile || audioFileUrl) {
        var _pause, _ref2;
        // Can't get the current AudioPlayer through the React hooks(useReducer or useState) in this scope
        var voiceAudioPlayerElement = document.getElementById(VOICE_PLAYER_AUDIO_ID);
        voiceAudioPlayerElement === null || voiceAudioPlayerElement === void 0 ? void 0 : (_pause = (_ref2 = voiceAudioPlayerElement).pause) === null || _pause === void 0 ? void 0 : _pause.call(_ref2);
      }
    };
  }, []);
  return {
    play: playVoicePlayer,
    pause: pauseVoicePlayer,
    stop: stopVoicePlayer,
    playbackTime: currentAudioUnit.playbackTime * 1000,
    duration: currentAudioUnit.duration * 1000,
    // the unit of playbackTime and duration should be millisecond
    playingStatus: currentAudioUnit.playingStatus
  };
};
export { useVoicePlayer };